import { useTranslation } from "react-i18next";

import { PriceDisplay } from "#modules/quoteRequestLines/PriceDisplay";
import { computeConsummablePrice, QuoteRequestLineForComputing } from "shared";

export const ConsumableCostDisplay = ({
  quoteRequestLine,
}: {
  quoteRequestLine: QuoteRequestLineForComputing;
}) => {
  const { t } = useTranslation();

  const { partCost } = computeConsummablePrice({
    quoteRequestLine,
    isQuotePrice: false,
  });

  return (
    <PriceDisplay primaryCostLabel={t("qrl.price.consumablePricePerPart")} primaryCost={partCost} />
  );
};
